import { useContext, createContext } from "react";
const OffsetContext = createContext("normal");
function useOffset() {
  const context = useContext(OffsetContext);
  if (context === "extra") {
    return 8;
  }
  return 4;
}
export {
  OffsetContext,
  useOffset
};
//# sourceMappingURL=OffsetContext.js.map
